import { render } from "./PromoCodes.vue?vue&type=template&id=37587dba&scoped=true"
import script from "./PromoCodes.vue?vue&type=script&lang=js"
export * from "./PromoCodes.vue?vue&type=script&lang=js"

import "./PromoCodes.vue?vue&type=style&index=0&id=37587dba&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37587dba"]])

export default __exports__